import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers';
// should we turn this off when download approvals is not setup?
// and if so, do we have all the information needed, for any user level, to determine this?
export const canManageDownloadRequests = (): boolean => {
	if (!currentUserMeetsUserLevel(UserLevel.DIRECTOR)) return false;
	return currentUserHasAccess(PermissionName.APPROVE_DOWNLOADS);
};
